import React, { JSX } from 'react';
import classNames from 'classnames';
import { Button } from 'antd';
import type { ButtonProps } from 'antd';

import AddCommentIconSvg from './addComment.svg';
import CommentIconSvg from './comment.svg';
import cn from './styles.module.scss';

export interface CommentIconButtonProps extends ButtonProps {
  commentsCount: number;
}

export const CommentIconButton = React.forwardRef<HTMLButtonElement | HTMLAnchorElement, CommentIconButtonProps>(
  ({ commentsCount = 0, className, type = 'text', ...props }, ref): JSX.Element => {
    const icon = commentsCount === 0
      ? <AddCommentIconSvg fill="currentColor" />
      : <CommentIconSvg fill="currentColor" />;

    return (
      <Button
        ref={ref}
        type={type}
        icon={icon}
        className={classNames(cn.commentButton, className)}
        data-testid="CommentIconButton"
        {...props}
      >
        {commentsCount > 0 && (
          <span className={cn.commentCountText}>{commentsCount}</span>
        )}
      </Button>
    );
  },
);
CommentIconButton.displayName = 'CommentIconButton';
